package de.oevbs.kunde.kundenportal2.model.services.inbox

import de.oevbs.businesspartner.bpcrmservice2.common.model.LineOfBusiness
import dev.fritz2.core.Lenses

enum class PatternState {
    /**
     * Pattern kann bearbeitet / gelöscht werden
     */
    Active,

    /**
     * Pattern kann für die Filterung angewendet werden
     */
    Readonly
}

@Lenses
data class InboxFilter(val pattern: String, val patternState: PatternState, val sparte: LineOfBusiness) {
    companion object {
        val emptyFilter = InboxFilter("", PatternState.Active, LineOfBusiness.Unbekannt)
    }

    fun usePattern(): Boolean = pattern.isNotBlank() && patternState == PatternState.Readonly
}